import { css } from 'styled-components'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { BP } from 'resources/constants'

export const cmsSidebarNavCss = css`
  background: #fff;
  margin: 0 0 20px;
  padding: 0;
  display: none;

  @media (min-width: ${BP.sm.min}) {
    margin: 0 0 0 3rem;
    padding: 30px 30px 15px;
    min-width: 240px;
    border: 1px solid ${props => props.theme.palette.general.borderColorLight};
    position: sticky;
    top: 130px;
    display: block;
  }

  h4 {
    display: none;

    @media (min-width: ${BP.sm.min}) {
      display: block;
    }
  }

  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ul {
    margin-top: 10px;

    li {
      a {
        display: block;
        padding: 10px 0;
        border-bottom: 1px solid ${props => props.theme.palette.general.borderColorLight};
        color: ${props => props.theme.palette.general.headerColor};
        text-decoration: none;
        font-weight: ${props => props.theme.font.default.medium};

        &:hover {
          color: ${props => props.theme.palette.primary.alphaDark};
        }
      }

      &:last-child {
        a {
          border: 0;
        }
      }
    }
  }
`

export const cmsTextBlockCss = css`
  .header {
    font-size: 24px;
    line-height: 1.1;
    font-family: ${props => props.theme.font.alt.family};
    color: ${props => props.theme.palette.general.textColor};
    padding: 0 0 10px;
    margin: 0;
    font-weight: 400;

    @media (min-width: ${BP.sm.min}) {
      font-size: 28px;
    }

    @media (min-width: ${BP.lg.min}) {
      font-size: 34px;
    }

    em {
      font-size: 0.6em;
      font-style: italic;
      color: ${props => props.theme.palette.general.textColorLight};
    }
  }

  p {
    margin: 0 0 20px;
    line-height: 1.55;
    color: ${props => props.theme.palette.general.textColor};

    &:only-child,
    &:last-child {
      margin: 0;
    }
  }
`

export const cmsSectionHeroCss = css`
  ${sectionCss}
  padding: 0 !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;

  p {
    @media (min-width: ${BP.lg.min}) {
      font-size: 18px;
    }
  }

  .img-setter {
    width: 100%;
    max-width: ${BP.max};
    text-align: center;
    line-height: 0;

    img {
      margin: 0 auto;
      width: 100%;
      height: auto;

      &.desktop {
        display: none;

        @media (min-width: ${BP.md.min}) {
          display: block;
        }
      }

      &.mobile {
        display: block;

        @media (min-width: ${BP.md.min}) {
          display: none;
        }
      }
    }

    &.img-bridge {
      display: none;

      @media (min-width: ${BP.md.min}) {
        display: block;
      }
    }
  }

  .container {
    ${containerCss}

    @media (max-width: ${BP.md.max}) {
      width: auto;
      max-width: none;
    }

    @media (min-width: ${BP.md.min}) {
      position: absolute;
      top: 0;
      left: 15px;
      right: 15px;
      bottom: 0;
      z-index: 2;
      display: flex;
      align-items: center;
    }
  }
`
